// Apply theme runtime configuration to <body>.
// Must run before main.js, which reads these classes and data-* attributes
// at module load time.
const BODY_CLASSES = [
  "lqd-pf-single",
  "lqd-pf-single-style-1",
  "lqd-preloader-style-curtain",
  "lqd-stack-buttons-style-1",
  "lqd-stack-nav-style-4",
  "lqd-stack-nums-style-2",
  "lqd-stack-nav-numbers-visible",
  "site-wide-layout",
];

const BODY_DATASET = {
  mobileNavBreakpoint: "1199",
  mobileNavStyle: "modern",
  mobileNavScheme: "dark",
  mobileNavTriggerAlignment: "right",
  mobileHeaderScheme: "gray",
  mobileLogoAlignment: "default",
  lqdCc: "true",
  ccOptions: '{"outerCursorHide":true}',
};

document.body.classList.add(...BODY_CLASSES);
for (const [key, value] of Object.entries(BODY_DATASET)) {
  document.body.dataset[key] = value;
}
